import React, { useContext, useEffect, useState } from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { JobNames, getJobNameByTbName, getOpByjobName } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, utCommunicationListItem } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { DocumentType } from '../../framework.core/DocumentType';
import { UTCommunicationListItem } from '../../fms.data/models/UTCommunicationListItem';
import Select from '../../ui/Select';
import { useHistory } from 'react-router';
import { NavigationType, openNewPage } from '../../util/navigationHelpers';

function useOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function viewRelatedFor(row: UTCommunicationListItem | null) {
    if (!row || !row.tbName || !row.tbId) {
      return;
    }
    const jobName = getJobNameByTbName(row.tbName);
    const opName = getOpByjobName(jobName);
    jobListContext.setFilterForScreenExternally(`/common/joblistview/${jobName}/${opName}`,
      'id', '', row.tbId.toString(), 'update', false, true, null,null,null,false,true);
    openNewPage(history, `/common/joblistview/${jobName}/${opName}`, NavigationType.newPage);
  }
  return { viewRelatedFor };
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);   

  const { viewRelatedFor } = useOperations();

  function viewRelated() {
    const selectedElement = jobListContext.selectedElement as UTCommunicationListItem;
    viewRelatedFor(selectedElement);
  }
  return {viewRelated};
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const jobListContext = useContext(JobListViewContext);

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function LogTypeFilterRenderer({ value, onChange, onEnter }: any) {
  return (
    <Select
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { label: 'Email', value: 'Email'},
        { label: 'Print', value: 'Print' },
        { label: 'Fax', value: 'Fax' },
      ]}
      applySearchWithEnter={onEnter}
    />
  );
}

function ListCommands() {
  return (
    // <div className="ifms-common-no-vertical-separator">
    //   <UniqueLinkButton display="primary" size="regular" link={''} disabled
    //                     label={<span><FontAwesomeIcon icon={faPlus}/>&nbsp; New</span>}/>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faFileAlt}/>&nbsp; View</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faPencilAlt}/>&nbsp; Edit</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={faTrashAlt}/>&nbsp; Delete</PrimaryButton>&nbsp;
    // </div>
    <></>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatLogType(s: string | null | undefined) {
  if (!s) {
    return s;
  }

  if (s === 'E') {
    return 'Email';
  }
  if (s === 'F') {
    return 'Fax';
  }
  if (s === 'P') {
    return 'Print';
  }

  return s
}

function LogTypeRenderer({ cell }: any) {
  return (
    <div className="ifms-table-default" >{formatLogType(cell.value)}</div>
  );
}

function ListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });
  const jobListContext = useContext(JobListViewContext);
  
  const { viewRelated } = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    } else if (unprocessedFkey === "F6") {
      viewRelated();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F6', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.LogCommunication}
      jobId={(jobListContext.selectedElement as UTCommunicationListItem | null)?.id ?? 0}
      customTabs={[
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 *
 * @class EmailLogListView
 * @extends {AbstractListView}
 */
class EmailLogListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.LogCommunication,
      'UTCommunicationListItem',
      UTCommunicationListItem.calculateSearchParameters(search, UTCommunicationListItem.MapSearchFields),
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: UTCommunicationListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'logType',
        renderer: LogTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v === 'Email' ? 'E' : v === 'Fax' ? 'F' : 'P',
      }
    ];
  }

  getInfoAreaEntityId() {
    return constants.opTypes.utility;
  }

  getRowRenderers(): ListRowRenderer[] {
    return UTCommunicationListItem.getExportCollection().map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.dataIndex === "logType") colRenderer.Cell = LogTypeRenderer;
      if (x.type === XCol.XCellType.Double) colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = utCommunicationListItem;
    const cols = UTCommunicationListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar />
    );
  }


  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras />
  }

  getViewUrlFor(row: UTCommunicationListItem) {
    return '';
  }

  getOpenUrlFor(row: UTCommunicationListItem) {
    function sanitizeFileName(fileName: string) {
      return fileName
        ?.replaceAll(/\:/g, '-')                // 윈도우 파일시스템 제한 문자
        ?.replaceAll(/[/\\?%*|"<>+]/g, ' ')     // 윈도우 파일시스템 제한 문자 && 업로드 파일 URL 호출 시 특수문자가 포함되어 있을 경우 에러가 발생함("+" 문자 추가)
        ?.replaceAll(/\./g, ' ')                // 마침표를 공백으로            ???
        ?.replaceAll(/\#/g, ' ')                // #을 공백으로                ???
        ?.replaceAll(/\s+/g, ' ')               // 연속된 공백을 하나로
        ?.trim();                               // 앞뒤 공백 제거
    }

    let url = '';
    const title = sanitizeFileName(row.title);
    if (row.logType === 'E')
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogEmail}&oriLogFileTitle=${title}`;

    else if (row.logType === 'P')
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogPrint}&oriLogFileTitle=${title}`;

    else
      url = `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogFax}&oriLogFileTitle=${title}`;

    return url;
  }

  getListViewTitle() {
    return 'Communication Log List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.LogCommunication} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default EmailLogListView;